<script setup lang="ts">
import type { Entry } from "contentful";

// Composables
const localePath = useLocalePath();

const { state, locations = undefined } = defineProps<{
  state: TBookingWidgetState;
  locations?: Entry | Entry[];
}>();

const travelDataStore = useTravelDataStore();

if (state == "prefilled location" && locations) {
  // This lets the widget preselect the location
  // @ts-expect-error because the state is not typed and initalized with "undefined", type is not correctly inferred as string or undefined
  // Please note that the current implementation of HotelSearchBar does not support mixed / multiple hotel codes
  travelDataStore.hotelCodes = Array.isArray(locations)
    ? locations[0].fields.code
    : locations.fields.code;
}

travelDataStore.checkTraveldata();
</script>

<template>
  <div class="ctf-booking-widget">
    <HotelSearchBar
      bar
      has-shadow
      :start="travelDataStore.arrivalDate"
      :end="travelDataStore.departureDate"
      :location="travelDataStore.hotelCodes"
      :submit-url="localePath('/book')"
    />
  </div>
</template>
